import { render, staticRenderFns } from "./courseConfigurationItem.vue?vue&type=template&id=3a980e0e&lang=pug&"
import script from "./courseConfigurationItem.vue?vue&type=script&lang=js&"
export * from "./courseConfigurationItem.vue?vue&type=script&lang=js&"
import style0 from "./courseConfigurationItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports